import { Link } from 'react-router'

import { strings } from '@/lib/strings'

export function NotFoundPage() {
  return (
    <section className="py-16 text-center">
      <h1 className="text-2xl font-semibold">{strings.notFound.title}</h1>
      <Link to="/" className="mt-4 inline-block text-accent underline">
        {strings.notFound.action}
      </Link>
    </section>
  )
}
